import React, { useMemo, useState } from 'react';
import { DModal, DPageLoader } from '../../../../../dum';
import { OrderQuotationIcon } from '../../../../icons';
import { OrderQuotationForm } from './order-quotation-form';
import { useOrderQuotationDialogQuery } from '../../../../../../services';

interface ISOrderQuotationFormDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderQuotationId?: number | null;
}

export const SUpsertOrderQuotationDialog = (
    props: ISOrderQuotationFormDialogProps,
) => {
    const { open, setOpen, orderQuotationId } = props;
    const [isModalClosing, setIsModalClosing] = useState(false);
    const { data, loading } = useOrderQuotationDialogQuery({
        skip: !orderQuotationId || !open,
        variables: {
            OrderQuotationId: orderQuotationId!,
        },
    });

    const orderQuotation = useMemo(() => {
        return orderQuotationId && data && data.getOrderQuotation && open
            ? data.getOrderQuotation
            : undefined;
    }, [orderQuotationId, data, open]);

    return (
        <DModal
            icon={<OrderQuotationIcon />}
            title={`Cotización`}
            open={open}
            setOpen={setOpen}
            onExited={() => {
                setIsModalClosing(false);
            }}
        >
            {loading ? (
                <DPageLoader />
            ) : (
                <OrderQuotationForm
                    disabled={
                        isModalClosing ||
                        (orderQuotation && !orderQuotation?.is_editable)
                    }
                    orderQuotation={orderQuotation}
                    onSuccess={() => {
                        setIsModalClosing(true);
                        setOpen(false);
                    }}
                />
            )}
        </DModal>
    );
};
